export default __webpack_public_path__ + "static/media/bg-hi-tech.c2ee81b7.jpeg";